import { PagePlaceholder } from '../_PagePlaceholder';
export function ReportsPage() {
  return <PagePlaceholder title="Reports" />;
}
